import { render, staticRenderFns } from "./newstore_confirm.vue?vue&type=template&id=1ed52e68&scoped=true&"
import script from "./newstore_confirm.vue?vue&type=script&lang=js&"
export * from "./newstore_confirm.vue?vue&type=script&lang=js&"
import style0 from "./newstore_confirm.vue?vue&type=style&index=0&id=1ed52e68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed52e68",
  null
  
)

export default component.exports